import Api from "@/utils/api";

const state = {
  user: {},
  token: null,
  todos: [],
  prefix: null,
  isLoading: false,
  tracker:{}
};
const getters = {
  getPrefix(state) {
    return state.prefix;
  },
  getUserRole(state) {
    return state.user.role;
  },
  getUser(state) {
    return state.user;
  },
  getToken(state) {
    return state.token;
  },
  getTracker(state){
    return state.tracker;
  },
  getName(state) {
    return `${state.user.firstName} ${state.user.lastName}`;
  },
  getLoader(state) {
    return state.isLoading;
  },
};
const mutations = {
  setTenantPrefix(state, data) {
    state.prefix = data;
  },
  setToken(state, token) {
    return (state.token = token);
  },
  setUser(state, data) {
    return (state.user = data);
  },
  setLearnerTracker(state,data){
    return (state.tracker = data);
  },
  updateLoader(state, data) {
    return (state.isLoading = data);
  },
};
const actions = {
  async login({ commit }, payload) {
    let res = await Api.post("/auth/login", payload);
    if (res.status === 200 || res.status === 201) {
      localStorage.setItem("lms-user", JSON.stringify(res.data.user));
      localStorage.setItem("lms-token", JSON.stringify(res.data.access_token));
      commit("setToken", res.data.access_token);
      commit("setUser", res.data.user);
      // commit("setTracker", res.data);
      return true;
    } else {
      return res;
    }
  },



  async forgotPassword({ commit }, payload) {
    let res = await Api.post(`auth/forgot-password`, payload);
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },

  async loginWithoutPassword({commit},payload){
    let res = await Api.post('auth/login-without-password',payload,true);
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },


  async passwordChange({ commit }, payload) {
    let res = await Api.post(`auth/change-password`, payload);
    if (res.status === 200 || res.status === 201) {
      return true;
    } else {
      return res;
    }
  },
  async register({ commit }, payload) {

    payload.uri = window.location.href;
    if (window.location.hostname === 'localhost') payload.uri = 'https://tomide-inc.edc.hostville.link/learner/register'
    // payload.uri = process.env.VUE_APP_TENANT_URI;
    let res = await Api.post("/learner/register", payload);
    return res;
  },
  async tenantLogin({ commit, dispatch }, payload) {
    let res = await Api.post("auth/tenant/login", payload);
    if (res.status === 200 || res.status === 201) {
      
      // learner: oluwaseunalamu@gmail.com|password
      //console.log({ res });
      if (res.data.login_type === "cross") {
        commit("setTenantPrefix", res.data.tenant_prefix);
        await dispatch("fetchTenantSettings", {
          prefix: res.data.tenant_prefix,
        });

        localStorage.setItem("lms-user", JSON.stringify(res.data.user));
        localStorage.setItem("lms-tracker", JSON.stringify(res.data));
        localStorage.setItem(
          "lms-token",
          JSON.stringify(res.data.access_token)
        );
        commit("setToken", res.data.access_token);
        commit("setUser", res.data.user);
        return true;
      } else {
        let prefix =
          typeof res.data.user.tenant_profile !== "undefined"
            ? res.data.user.tenant_profile.tenant_prefix
            : res.data.user.tenant.tenant_prefix;
        commit("setTenantPrefix", prefix);
        await dispatch("fetchTenantSettings", { prefix });

        localStorage.setItem("lms-user", JSON.stringify(res.data.user));
        localStorage.setItem(
          "lms-token",
          JSON.stringify(res.data.access_token)
        );
        localStorage.setItem("lms-tracker", JSON.stringify(res.data.courseStat));
        commit("setToken", res.data.access_token);
        commit("setUser", res.data.user);
        commit("setLearnerTracker", res.data.courseStat);
        return true;
      }
    } else {
      return res;
    }
  },

  async updateProfile({ commit }, payload) {
    let res = await Api.put("user/update-profile", payload, true);
    commit("setUser", res.data.data.learner);
    return res;
  },

  async fetchUserDetailsProfile({ commit }, payload) {
    let res = await Api.get(`user/${payload.id}/show`, payload, true);
    return res;
  },

  async fetchProfile({ commit }, payload) {
    let res = await Api.get("user", true);
    return res;
  },

  async fetchNotificationSettings({ commit }, payload) {
    let res = await Api.get("user/notification-settings", true);
    //console.log({ res });
    return res.data.data.notification_settings;
  },

  async updateNotificationSettings({ commit }, payload) {
    let res = await Api.put("user/notification-settings", payload, true);
    return res;
  },

  async updateToken({ commit }, payload) {
    let res = await Api.put("user/update-device-token", payload, true);
    return res;
  },

  async logout({ commit }) {
    commit("setToken", "");
    commit("setUser", {});
    const item = localStorage.getItem('has_browser_question')
    const reminder = localStorage.getItem('reminder')
    localStorage.clear();
    localStorage.setItem('has_browser_question',item)
    localStorage.setItem('reminder',reminder)
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
